<template>
  <svg
    width="42"
    height="42"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.5"
      cy="13"
      r="12.125"
      fill="var(--livi-primary)"
      stroke="#E0E0E0"
      stroke-width="0.75"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.35712 13.0003C6.35712 9.608 9.10769 6.85742 12.5 6.85742C15.8923 6.85742 18.6428 9.608 18.6428 13.0003C18.6428 16.3926 15.8923 19.1431 12.5 19.1431C9.10769 19.1431 6.35712 16.3926 6.35712 13.0003ZM7.39921 13.0003C7.39921 15.8167 9.68358 18.101 12.5 18.101C15.3164 18.101 17.6007 15.8167 17.6007 13.0003C17.6007 10.1839 15.3164 7.89951 12.5 7.89951C9.68358 7.89951 7.39921 10.1839 7.39921 13.0003ZM12.0346 11.0524C11.9111 10.929 11.8418 10.7616 11.8418 10.587C11.8418 10.4125 11.9111 10.2451 12.0346 10.1216C12.158 9.99819 12.3254 9.92885 12.5 9.92885C12.6745 9.92885 12.8419 9.99819 12.9654 10.1216C13.0888 10.2451 13.1581 10.4125 13.1581 10.587C13.1581 10.7616 13.0888 10.929 12.9654 11.0524C12.8419 11.1758 12.6745 11.2452 12.5 11.2452C12.3254 11.2452 12.158 11.1758 12.0346 11.0524ZM12.1709 12.1227H12.829C12.8894 12.1227 12.9387 12.1721 12.9387 12.2324V15.962C12.9387 16.0223 12.8894 16.0717 12.829 16.0717H12.1709C12.1106 16.0717 12.0612 16.0223 12.0612 15.962V12.2324C12.0612 12.1721 12.1106 12.1227 12.1709 12.1227Z"
      fill="white"
    />
  </svg>
</template>
